import { render, staticRenderFns } from "./TelephoneNumberField.vue?vue&type=template&id=590b93a0&"
import script from "./TelephoneNumberField.vue?vue&type=script&lang=js&"
export * from "./TelephoneNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports